/* src/app/modules/portal/components/lastDataSourceRefresh/lastDataSourceRefresh.component.scss */
:host {
  width: 100%;
}
sh-spinner {
  margin: auto;
}
api-call-gate {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.states {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}
.states .item {
  width: 100%;
}
app-srsrefreshbutton {
  min-width: initial !important;
  display: flex;
  flex-direction: row;
  margin-right: auto;
  margin-left: none;
  justify-content: right;
}
[cols="2"] :host-context .item {
  width: calc(50% - 0.5rem);
}
[cols="3"] :host-context .states {
  flex-wrap: nowrap;
}
/*# sourceMappingURL=lastDataSourceRefresh.component.css.map */
